import { css } from 'styled-components';
import token from 'styled-token';
import { focusMixin } from '../focusMixin';
import { hoverMediaQueryMixin } from '../hoverMediaQueryMixin';
import { spaceMixin } from '../spaceMixin';
import { spacingMixin } from '../spacingMixin';
import { typographyMixin } from '../typographyMixin';

/** @class CardButtonMixin */
/** @method */
export var CardButtonMixin = function CardButtonMixin(props) {
  return token({
    borderColor: 'Card.separatorColor',
    borderWidthTop: 'CardButton.borderWidthTop',
    color: 'CardButton.fontColor',
    fontType: 'CardButton.fontType',
    hoverTextDecoration: 'CardButton.textDecoration.hover',
    marginTop: 'CardButton.marginTop',
    padding: 'CardButton.padding',
    paddingTop: 'CardButton.paddingTop',
    textAlign: 'CardButton.textAlign',
    width: 'CardButton.width'
  }, function (_ref) {
    var borderColor = _ref.borderColor,
      _ref$borderWidthTop = _ref.borderWidthTop,
      borderWidthTop = _ref$borderWidthTop === void 0 ? 1 : _ref$borderWidthTop,
      color = _ref.color,
      fontType = _ref.fontType,
      _ref$hoverTextDecorat = _ref.hoverTextDecoration,
      hoverTextDecoration = _ref$hoverTextDecorat === void 0 ? 'underline' : _ref$hoverTextDecorat,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 0 : _ref$padding,
      marginTop = _ref.marginTop,
      paddingTop = _ref.paddingTop,
      _ref$textAlign = _ref.textAlign,
      textAlign = _ref$textAlign === void 0 ? 'center' : _ref$textAlign,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width;
    return css(["", " color:", ";padding:", "px;border:0;background:transparent;text-align:", ";border-top:", "px solid ", ";display:block;width:", ";padding-top:", ";margin-top:", ";cursor:pointer;outline:none;", " ", ";", ""], typographyMixin(Object.assign({
      fontType: fontType
    }, props)), color, padding, textAlign, borderWidthTop, borderColor, width, paddingTop ? paddingTop + "px" : spaceMixin('sm')(props), marginTop ? marginTop + "px" : spaceMixin('md')(props), focusMixin(props), hoverMediaQueryMixin("\n                text-decoration: " + hoverTextDecoration + ";\n            "), spacingMixin(props));
  })(props);
};